/* Consentimiento Descorcha, 2026-09-24: este cargador de Insider (incluida su consulta a ipapi.co)
   corre SOLO si el visitante acepta "Marketing" en el banner de cookies. Lo llama el snippet
   consentimiento-descorcha con window.dclIniciarInsider(). El código original quedó igual, adentro. */
window.dclIniciarInsider = function () {
if (window.__dclInsiderIniciado) return;
window.__dclInsiderIniciado = true;
(function(){
  /* ================= CONFIG ================= */
  const INSIDER_SRC = "https://conchaytorocl.api.useinsider.com/ins.js?id=10012226";
  const SCORE_LIMIT   = 3;
  const SCORE_TIMEOUT = 4500;
  const COOKIE_NAME   = 'insider_descorcha';
  const COOKIE_TTL_ALLOW = 30; // minutos
  const COOKIE_TTL_BLOCK = 20;
  const DEBUG = new URLSearchParams(location.search)
                  .has('insider_debug');
  const log = (...a) => DEBUG && console.log('[INSIDER]', ...a);

  /* ================= COOKIE HELPERS ================= */

  function setCookie(name,value,minutes){
    const expires = new Date(Date.now()+minutes*60000).toUTCString();
    document.cookie =
      name + '=' + value +
      '; expires=' + expires +
      '; path=/; SameSite=Lax; Secure';
  }

  function getCookie(name){
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name+'='))
      ?.split('=')[1];
  }

  /* ================= STATE ================= */

  let loaded  = false;
  let blocked = false;
  let score = 0;

  let hasActiveSignal = false;
  let hasScrollAfterActive = false;

  /* ================= STORAGE ================= */

  const DECISION_KEY = '__INSIDER_DECISION__';
  const REASON_KEY   = '__INSIDER_REASON__';

  /* ================= COOKIE CACHE ================= */

  // const cookieDecision = getCookie(COOKIE_NAME);

  // if (cookieDecision) {
  //   log('Cookie decision:', cookieDecision);
  //   if (cookieDecision === 'allow') loadInsider('cookie');
  //   return;
  // }

  /* ================= SESSION CACHE ================= */

  const savedDecision = sessionStorage.getItem(DECISION_KEY);
  const savedReason   = sessionStorage.getItem(REASON_KEY);

  if (savedDecision) {
    log('Session decision:', savedDecision, savedReason);
    if (savedDecision === 'allow') loadInsider(savedReason);
    return;
  }

  /* ================= CORE ================= */

  function loadInsider(reason){
    if (loaded || blocked) return;
    loaded = true;

    sessionStorage.setItem(DECISION_KEY,'allow');
    sessionStorage.setItem(REASON_KEY,reason);
    // setCookie(COOKIE_NAME,'allow',COOKIE_TTL_ALLOW);

    log('LOADED via', reason);

    const s = document.createElement('script');
    s.src = INSIDER_SRC;
    s.async = true;
    document.head.appendChild(s);
  }

  function block(reason){
    if (loaded || blocked) return;
    blocked = true;

    sessionStorage.setItem(DECISION_KEY,'block');
    sessionStorage.setItem(REASON_KEY,reason);
    // setCookie(COOKIE_NAME,'block',COOKIE_TTL_BLOCK);

    log('BLOCKED via', reason);
  }

  /* ================= IP GEO ================= */

  fetch('https://ipapi.co/json/?key=BzfsJCns9b1Akt5gWc3IHhq73UA0Lq4PyZiGWITP8uKdVp81qi', { cache:'no-store' })
    .then(r=>r.json())
    .then(d=>{
      // log('IP country:', d.country_code);

      if (d.country_code === 'CN') {
        block('ip');
      } else {
        loadInsider('ip');
      }
    })
    .catch(()=>{
      log('IP failed -> fallback score');
      initScore();
    });

  /* ================= SCORE HUMANO ================= */

  function initScore(){

    function activeSignal(type){
      if (!hasActiveSignal) {
        hasActiveSignal = true;
        score += 2;
        log('Active signal:', type);
      }
    }

    ['click','keydown','touchstart','mousedown'].forEach(e=>{
      addEventListener(e,()=>activeSignal(e),{
        passive:true,
        once:true
      });
    });

    addEventListener('scroll',()=>{
      if (!hasActiveSignal) return;
      if (!hasScrollAfterActive) {
        hasScrollAfterActive = true;
        score += 1;
        log('Scroll after active');
      }
    },{passive:true});

    document.addEventListener('visibilitychange',()=>{
      if (!document.hidden && hasActiveSignal) {
        score += 1;
        log('Tab return');
      }
    });

    if (navigator.webdriver) {
      score -= 10;
      log('Headless detected');
    }

    setTimeout(()=>{
      if (loaded || blocked) return;

      const pass = score >= SCORE_LIMIT && hasActiveSignal;

      log('FINAL SCORE', { score, pass });

      pass ? loadInsider('score') : block('score');

    }, SCORE_TIMEOUT);
  }

})();
};
if (window.dclInsiderPermitido) window.dclIniciarInsider();
